function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './TabsHorizontal.css';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { getColorByTheme, getPageThemeColors, get, canUseDOM, hexToRgb } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { isNil } from '../../utils/IsNil';
import { qsToObject } from '../../utils/querystring';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
import { ReactComponent as IconBoldChevronRight } from '../../resources/icons/IconBoldChevronRight.svg';
import { checkJssError } from '../../utils/checkJssError';
const classItemWidthMap = {
  1: "oneItem",
  2: "twoItem",
  3: "threeItem",
  4: "fourItem"
};
const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
const getCorpTopPosition = () => window.matchMedia('(min-width: 993px)').matches ? '174' : window.matchMedia('(min-width: 768px) and (max-width: 992px)').matches ? '131' : isMobile() ? '57' : 'auto';
const getSCTopPosition = () => window.matchMedia('(min-width: 993px)').matches ? '68' : window.matchMedia('(min-width: 768px) and (max-width: 992px)').matches ? '51' : isMobile() ? '51' : 'auto';
const getTopPosition = () => window.matchMedia('(min-width: 993px)').matches ? '35' : window.matchMedia('(min-width: 768px) and (max-width: 992px)').matches ? '51' : isMobile() ? '51' : 'auto';
const getTagsValue = location => canUseDOM ? qsToObject(location.search)['tags'] || '' : '';
const TabsHorizontalComponent = _ref => {
  let {
    fields,
    params
  } = _ref;
  const tabsHorizontalContainerRef = useRef(null);
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const location = useLocation();
  const [isVdsite, setIsVdsite] = useState(true);
  const [currentSectionAnchor, setCurrentSectionAnchor] = useState('');
  const [leftButtonVisibility, setLeftButtonVisibility] = useState(false);
  const [rightButtonVisibility, setRightButtonVisibility] = useState(false);
  const [tagsValue] = useState(() => getTagsValue(location));
  const links = get(fields, 'data.datasource.items', []);
  const isStickyMode = get(params, 'isSticky', false);
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }

  /* Params elements */
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  const variables = BackgroundColorHex ? {
    '--tabs-horizontal-background-color': BackgroundColorHex,
    '--tabs-horizontal-background-color-rgb': hexToRgb(BackgroundColorHex, true),
    '--tabs-horizontal-background-active-color': ActiveColorHex,
    '--tabs-horizontal-color': ColorHex
  } : {
    '--tabs-horizontal-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--tabs-horizontal-background-color-rgb': hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    '--tabs-horizontal-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--tabs-horizontal-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const anchorHandler = anchor => {
    if (isNil(anchor) || anchor.trim() === '') {
      return;
    }
    const anchorElement = document.querySelector(`[data-anhor=${anchor}]`);
    anchorElement && anchorElement.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const anchorAddScrollStyles = () => {
    const tabs = document.getElementsByClassName('tabs-wrapper')[0].getBoundingClientRect();
    const tabsHeight = tabs.height;
    const tabsYPosition = tabs.top + window.scrollY;
    document.querySelectorAll('[data-anhor]').forEach(anchorElement => {
      const anchorYPosition = anchorElement.getBoundingClientRect().top + window.scrollY;
      if (anchorYPosition <= tabsYPosition) {
        const offset = window.matchMedia('(max-width: 992px)').matches ? 72 : 55;
        anchorElement.style.scrollMarginTop = `${tabsHeight + offset}px`;
        return;
      }
      anchorElement.style.scrollMarginTop = `${tabsHeight}px`;
    });
  };
  const tabPositionChanger = () => {
    let prevScrollPos = window.pageYOffset;
    return function () {
      const tabs = document.querySelector('.stickyTabContainer');
      if (isNil(tabs)) {
        return;
      }
      const currentScrollPos = window.pageYOffset;
      const scNav = canUseDOM ? document.querySelector('.sc-navigation') : null;
      const corpNav = canUseDOM ? document.querySelector(".CORP") : null;
      if (scNav) {
        // always visible header
        tabs.style.top = `${getSCTopPosition()}px`;
        return;
      }
      if (corpNav) {
        // always visible header
        if (prevScrollPos > currentScrollPos) {
          // Scrolling up
          tabs.style.top = `${getCorpTopPosition()}px`;
        } else {
          // Scrolling down
          tabs.style.top = window.matchMedia('(max-width: 768px)').matches ? `${getCorpTopPosition()}px` : `${parseInt(getCorpTopPosition()) - 45}px`;
        }
        prevScrollPos = currentScrollPos;
        return;
      }
      if (prevScrollPos > currentScrollPos) {
        // Scrolling up, show header
        tabs.style.top = `${getTopPosition()}px`;
      } else {
        // Scrolling down, hide header
        tabs.style.top = '-21px';
      }
      prevScrollPos = currentScrollPos;
    };
  };
  const addStickyStyles = () => {
    const tabs = document.querySelector('.stickyTabContainer');
    if (isNil(tabs)) {
      return;
    }
    tabs.style.top = '-21px';
    tabs.style.position = 'sticky';
    tabs.style.transition = 'all .4s linear';
    tabs.style.zIndex = '8';
  };
  const handleActiveTab = () => {
    const tabs = document.querySelector('.stickyTabContainer');
    return function () {
      const tabsRect = tabs.getBoundingClientRect();
      const anhorSections = document.querySelectorAll('[data-anhor]');
      Array.from(anhorSections).some(anhorSection => {
        const anhorSectionRect = anhorSection.getBoundingClientRect();
        const tabsYBottomPosition = tabsRect.bottom + window.scrollY;
        const anchorYTopPosition = anhorSectionRect.top + window.scrollY;
        const anchorYBottomPosition = anhorSectionRect.bottom + window.scrollY;
        if (anchorYTopPosition <= tabsYBottomPosition && tabsYBottomPosition < anchorYBottomPosition) {
          const anhor = anhorSection.getAttribute('data-anhor');
          setCurrentSectionAnchor(anhor);
          return true;
        } else {
          setCurrentSectionAnchor('');
        }
      });
    };
  };
  const observeTabsPosition = () => {
    const tabs = document.querySelector('.stickyTabContainer');
    const tabsTop = tabs.getBoundingClientRect().top;
    const currentTopPosition = getTopPosition();
    if (isMobile() || isMobile() && tabs.classList.contains('stickyTabContainerBefore')) {
      tabs.classList.remove('stickyTabContainerBefore');
      return;
    }
    tabs.classList.toggle('stickyTabContainerBefore', tabsTop <= parseInt(currentTopPosition));
  };
  const observeHashChange = event => {
    const newURLString = event && event.newURL;
    if (newURLString) {
      anchorHandler(new URL(newURLString).hash.substring(1));
    }
  };
  useEffect(() => {
    window.addEventListener('hashchange', observeHashChange);
    if (isStickyMode) {
      addStickyStyles();
      anchorAddScrollStyles();
      handleActiveTab()();
      observeTabsPosition();
      window.addEventListener('resize', checkForDisabledButtons);
      window.addEventListener('touchend', checkForDisabledButtons);
      window.addEventListener('scroll', handleActiveTab());
      window.addEventListener('scroll', anchorAddScrollStyles);
      window.addEventListener('scroll', tabPositionChanger());
      window.addEventListener('scroll', observeTabsPosition);
    }
    checkForDisabledButtons();
    return () => {
      window.removeEventListener('hashchange', observeHashChange);
      if (isStickyMode) {
        window.removeEventListener('resize', checkForDisabledButtons);
        window.removeEventListener('touchend', checkForDisabledButtons);
        window.removeEventListener('scroll', anchorAddScrollStyles);
        window.removeEventListener('scroll', handleActiveTab());
        window.removeEventListener('scroll', tabPositionChanger());
        window.removeEventListener('scroll', observeTabsPosition);
      }
    };
  }, []);
  useEffect(() => {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  useEffect(() => {
    setTimeout(checkForDisabledButtons, 200);
  }, [sitecoreContext.selectedFontSize]);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('TabsHorizontal component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TabsHorizontal component is empty: please provide data source]");
    }
    return null;
  }
  const getAvgScrollWidth = childNodes => {
    let acc = 0;
    childNodes.forEach((el, index) => {
      if (childNodes.length - 1 === index) {
        acc = acc / index;
        return acc;
      }
      acc += el.offsetWidth;
      return acc;
    }, 0);
    return Math.round(acc) + 15;
  };
  const checkForDisabledButtons = () => {
    setTimeout(() => {
      const {
        scrollLeft,
        clientWidth,
        scrollWidth
      } = tabsHorizontalContainerRef.current;
      if (rtl) {
        if (scrollLeft === 0) {
          setLeftButtonVisibility(false); // the start of nav list, hide right button
        } else if (scrollLeft !== 0) {
          setLeftButtonVisibility(true);
        }
        if (parseInt((scrollWidth + parseInt(scrollLeft.toString())).toString()) === clientWidth || parseInt((scrollWidth + parseInt(scrollLeft.toString())).toString()) + 1 === clientWidth || parseInt((scrollWidth + parseInt(scrollLeft.toString())).toString()) - 1 === clientWidth) {
          setRightButtonVisibility(false); // the end of nav list, hide left button
          return;
        } else {
          return setRightButtonVisibility(true);
        }
      }
      if (scrollLeft === 0) {
        setRightButtonVisibility(false); // the start of nav list, hide left button
      } else if (scrollLeft !== 0) {
        setRightButtonVisibility(true);
      }
      if (parseInt((scrollWidth - parseInt(scrollLeft.toString())).toString()) === clientWidth || parseInt((scrollWidth - parseInt(scrollLeft.toString())).toString()) + 1 === clientWidth || parseInt((scrollWidth - parseInt(scrollLeft.toString())).toString()) - 1 === clientWidth) {
        setLeftButtonVisibility(false); // the end of nav list, hide right button
        return;
      } else {
        return setLeftButtonVisibility(true);
      }
    }, 200);
  };
  const scroll = scrollOffsetType => {
    const {
      scrollLeft,
      childNodes
    } = tabsHorizontalContainerRef.current;
    const averageScrollValue = getAvgScrollWidth(childNodes);
    if (scrollOffsetType === 'left') {
      tabsHorizontalContainerRef.current.scrollTo({
        left: !rtl ? scrollLeft - averageScrollValue : scrollLeft + averageScrollValue,
        behavior: 'smooth'
      });
    }
    if (scrollOffsetType === 'right') {
      tabsHorizontalContainerRef.current.scrollTo({
        left: !rtl ? scrollLeft + averageScrollValue : scrollLeft - averageScrollValue,
        behavior: 'smooth'
      });
    }
    checkForDisabledButtons();
  };
  const clickTabsHorizontalAnalytics = title => {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['clickTabsHorizontalAnalytics'], _objectSpread(_objectSpread(_objectSpread({}, params), eventsAnalytics['clickTabsHorizontalAnalytics'].eventAct && {
      eventAct: eventsAnalytics['clickTabsHorizontalAnalytics'].eventAct
    }), eventsAnalytics['clickTabsHorizontalAnalytics'].eventCat !== 'Modules' && {
      eventCat: eventsAnalytics['clickTabsHorizontalAnalytics'].eventCat
    })), title);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('tabs-container', {
      'tabs-container--right-scroll': rightButtonVisibility,
      'tabs-container--left-scroll': leftButtonVisibility
    })
  }, /*#__PURE__*/React.createElement("nav", {
    className: "tabs-wrapper",
    ref: tabsHorizontalContainerRef
  }, links.map((item, index) => {
    const link = item.link.jss.value;
    const linkLabelValue = item.linkLabel.jss.value;
    const isActiveValue = item.isActive.jss.value;
    const generalClassName = `${classItemWidthMap[links.length]} tabs-wrapper__item`;
    return isActiveValue || currentSectionAnchor !== '' && currentSectionAnchor === link.anchor || tagsValue !== '' && link.href.includes(tagsValue) ? /*#__PURE__*/React.createElement("span", {
      key: `${index}-${link.href}`,
      className: `${generalClassName} tabs-wrapper__item--active`
    }, linkLabelValue) : /*#__PURE__*/React.createElement(RouterLink, {
      key: `${index}-${link.href}`,
      className: generalClassName,
      href: link.href,
      linktype: link.linktype,
      title: `${linkLabelValue} | ${link.title}`,
      onClick: () => {
        clickTabsHorizontalAnalytics(linkLabelValue);
      },
      openInSameTab: true
    }, linkLabelValue);
  })), rightButtonVisibility && links.length >= 5 ? /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['operatingOptionsAnalytics'], _objectSpread(_objectSpread(_objectSpread({}, params), eventsAnalytics['operatingOptionsAnalytics'].eventAct && {
        eventAct: eventsAnalytics['operatingOptionsAnalytics'].eventAct
      }), eventsAnalytics['operatingOptionsAnalytics'].eventCat !== 'Modules' && {
        eventCat: eventsAnalytics['operatingOptionsAnalytics'].eventCat
      })), 'previous');
      scroll(!rtl ? 'left' : 'right');
    },
    className: "tabsScrollButtonLeft"
  }, /*#__PURE__*/React.createElement(IconBoldChevronRight, {
    className: "icon leftIcon"
  })) : null, leftButtonVisibility && links.length >= 5 ? /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['operatingOptionsAnalytics'], _objectSpread(_objectSpread(_objectSpread({}, params), eventsAnalytics['operatingOptionsAnalytics'].eventAct && {
        eventAct: eventsAnalytics['operatingOptionsAnalytics'].eventAct
      }), eventsAnalytics['operatingOptionsAnalytics'].eventCat !== 'Modules' && {
        eventCat: eventsAnalytics['operatingOptionsAnalytics'].eventCat
      })), 'next');
      scroll(!rtl ? 'right' : 'left');
    },
    className: "tabsScrollButtonRight"
  }, /*#__PURE__*/React.createElement(IconBoldChevronRight, {
    className: "icon"
  })) : null));
};
const TabsHorizontal = props => checkJssError(props, TabsHorizontalComponent, props.fields.data.datasource);
const StyledWrapper = _ref2 => {
  let {
    rtl,
    children,
    style,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `stickyTabContainer ${commonStyles} ${globalStyles} ${rtl ? rtlStyles : ltrStyles}`,
    style: style,
    removePaddingMobile: true
  }, children);
};
const tabsScrollMixin = `
   text-align: center;
   border-radius: 4px;
   border: none;
   height: 35px;
   width: 35px;
   background: var(--tabs-horizontal-background-color);
   position: absolute;
   top: calc(50% - 17px);
   padding: 0;
   z-index: 1;
`;
const globalStyles = "gmr9eth";
const commonStyles = "cnk22g8";
const ltrStyles = "lkl5stt";
const rtlStyles = "roix15n";
export default TabsHorizontal;